import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import moment from 'moment';
import { Button, Loader } from 'oxyrion-ui/lib';
import { connect, actions } from '../../Store';
import {
  ResponsiveFlexWrapper,
  PartWrapper,
  SliderWrapper,
  AnimatedFormMessageWrapper,
  LoaderWrapper,
} from '../../Components/ReusableComponents';
import InfoTable from '../../Components/InfoTable';
import {
  formatPrice,
  formatPercents,
  __,
  normalizePlan,
  getColorForBrand,
  getColorByReceivablesGroup,
  translateDueDays,
  translateSpecialDiscountName,
  formatDate,
} from '../../Utils';
import TableHeaders from '../../ContentConfig/Dashboard/brandsTableHeader';
// import API from '../../API';
import ContactInfoPanel from '../../Components/ContactInfoPanel';
import YearsSlider from '../../Components/YearsSlider';
import Bonuses from '../../Components/Bonuses';
import TurnoverGraph from '../../Components/TurnoverGraph';
import BrandsGraph from '../../Components/BrandsGraph';
import ReceivablesGraph from '../../Components/ReceivablesGraph';
import InfoBox from '../../Components/InfoBox';
import ErrorMessage from '../../Components/ErrorMessage';
import API2 from '../../API2';

const StyledPartWrapper = styled(PartWrapper)`
  overflow-y: scroll;
  order: 2;
  padding-top: ${rem(20)};
  ${({ theme }) => theme.media.m`
  width: 65%;
  order: unset;
  padding-top: 0;
  overflow: unset;
`};
`;

const InfoBoxesWrapper = styled(ResponsiveFlexWrapper)`
  margin-top: ${rem(40)};
  margin-bottom: ${rem(10)};
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: start;
`;

const CenteredWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${rem(20)};
`;

const MainContainer = styled.div`
  padding: ${rem(16)};
`;

const CustomHeader = styled.div`
  font-weight: 100;
  font-size: 1.875rem;
  margin-bottom: 1.375rem;
`;

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
      receivables: [],
      graphBrands: [],
      discounts: [],
      specialDiscounts: [],
      graphReceivables: [],
      planData: [],
      contacts: [],
      plan: [],
      loading: true,
      loadingContacts: true,
      error: undefined,
      actualYear: new Date().getFullYear(),
      showShopState: false,
      customerBonuses: [],
      actualTurnover: 0,
    };

    moment.locale('sk', {
      months: 'januaru_februáru_marcu_aprílu_máju_júnu_julu_augustu_septembru_októbru_novemberu_decemberu'.split(
        '_',
      ),
      monthsShort: 'jan._feb._mar_apr._máj_jún_júl._aug_sept._okt._nov._dec.'.split(
        '_',
      ),
      monthsParseExact: true,
      weekdays: 'pondelok_utorok_streda_štvrtok_piatok_sobota_nedeľa'.split(
        '_',
      ),
      weekdaysShort: 'po._ut._st._št._pi._so._ne.'.split('_'),
    });
  }

  componentDidMount() {
    this.fetchData();
    actions.setActiveMenuItem('2');
    this.props.history.push('/home');
  }

  async fetchData() {
    const { actualYear } = this.state;

    let bonuses = [];
    try {
      const results = await Promise.all([
        API2.getB2BTurnoverByBrandAction({
          year: actualYear,
        }),
        API2.getB2BReceivablesAction({
          year: actualYear,
        }),
        API2.getB2BDiscountsAction(),
        API2.getB2BBonusesAction(),
        API2.getB2BTurnoverPlanAction({
          year: actualYear,
        }),
        API2.getB2BContactsAction(),
        API2.getB2BCustomerAction({ year: actualYear }),
      ]);
      const normalizedTurnoversForGraph = this.normalizeBrandsData(
        results[0] && results[0].turnovers,
      );

      const normalizedReceivablesData =
        results[1] && results[1].receivables
          ? results[1].receivables.map(r => {
              return [
                translateDueDays(r.due_days),
                r.total ? r.total.amount : 0,
              ];
            })
          : [];

      const normalizedReceivables = this.normalizeRecTableData(
        results[1] && results[1].receivables,
      );

      const normalizedTurnovers = this.normalizeTableData(
        results[0] && results[0].turnovers,
      );

      const normalizedDiscounts = this.normalizeDiscountsTableData(
        results[2] && results[2].discount_base,
      );

      const normalizedSpecialDiscounts = this.normalizeDiscountsTableData(
        results[2] &&
          results[2].discount_special.map(d =>
            Object.assign(d, { name: translateSpecialDiscountName(d.name) }),
          ),
      );

      bonuses = results[3].bonuses;

      const turnOverResult = results[4];
      const contactsResult = results[5];
      const customer = results[6];

      const customerBonuses =
        customer && customer.active_bonuses && customer.active_bonuses.bonuses
          ? customer.active_bonuses.bonuses.map(a => {
              const bonus = bonuses.find(b => b._id === a);

              return bonus
                ? Object.assign(bonus, {
                    value:
                      (this.props.user.firm === 'SK'
                        ? bonus.value_SK
                        : bonus.value_CZ
                      ).amount * (customer.active_bonuses.coefficient || 1),
                  })
                : undefined;
            })
          : [];

      const planData = this.preparePlanData(turnOverResult);

      this.setState({
        contacts: contactsResult.users,
        customerBonuses: customerBonuses.filter(c => c),
        customer,
        brands: normalizedTurnovers,
        receivables: normalizedReceivables,
        graphBrands: normalizedTurnoversForGraph,
        graphReceivables: normalizedReceivablesData,
        discounts: normalizedDiscounts,
        specialDiscounts: normalizedSpecialDiscounts,
        plan: turnOverResult,
        loading: false,
        loadingContacts: false,
        planData: planData.data,
        actualTurnover: planData.actualTurnover,
      });
    } catch (e) {
      console.log(e);
      switch (e.response.status) {
        case 404:
          this.setState({
            error: __('Dáta sa nepodarilo nájsť.'),
            loading: false,
          });
          break;
        case 403:
          this.setState({
            error: __('Nemáte potrebné práva.'),
            loading: false,
          });
          break;
        default:
          this.setState({
            error: __('Pri načítavaní dát sa vyskytla chyba.'),
            loading: false,
          });
      }
    }
  }

  async relaodYear() {
    const { actualYear } = this.state;
    this.setState({
      yearReloadLoading: true,
      error: undefined,
    });

    try {
      const results = await Promise.all([
        API2.getB2BTurnoverByBrandAction({
          year: actualYear,
        }),
        API2.getB2BReceivablesAction({
          year: actualYear,
        }),
        API2.getB2BTurnoverPlanAction({
          year: actualYear,
        }),
      ]);
      const normalizedTurnoversForGraph = this.normalizeBrandsData(
        results[0] && results[0].turnovers,
      );

      const normalizedReceivablesData =
        results[1] && results[1].receivables
          ? results[1].receivables.map(r => {
              return [
                translateDueDays(r.due_days),
                r.total ? r.total.amount : 0,
              ];
            })
          : [];

      const normalizedReceivables = this.normalizeRecTableData(
        results[1] && results[1].receivables,
      );

      const normalizedTurnovers = this.normalizeTableData(
        results[0] && results[0].turnovers,
      );

      this.setState({
        brands: normalizedTurnovers,
        receivables: normalizedReceivables,
        graphBrands: normalizedTurnoversForGraph,
        graphReceivables: normalizedReceivablesData,
        plan: results[2],
      });
    } catch (e) {
      switch (e.response.status) {
        case 404:
          this.setState({
            error: __('Údaje pre daný rok sa nepodarilo nájsť.'),
          });
          break;
        case 403:
          this.setState({ error: __('Nemáte potrebné práva.') });
          break;
        default:
          this.setState({
            error: __('Pri načítavaní dát sa vyskytla chyba.'),
          });
      }
    } finally {
      this.setState({
        yearReloadLoading: false,
      });
    }
  }

  normalizeBrandsData(data) {
    if (!data) {
      return [];
    }

    return data.map(d => {
      return [d.brand, d.percent];
    });
  }

  normalizeDiscountsTableData(data) {
    const _shapeData = value => {
      if (value) {
        return value;
      }
      return ' - ';
    };
    const result = data.reduce((acumulator, item) => {
      acumulator.push({
        cells: [
          {
            data: _shapeData(item.name),
            left: true,
          },
          {
            data: _shapeData(formatDate(moment(item.valid_from))),
            center: true,
          },
          {
            data: _shapeData(formatDate(moment(item.valid_to))),
            center: true,
          },
          {
            data: _shapeData(formatPercents(item.discount)),
            right: true,
          },
        ],
      });
      return acumulator;
    }, []);
    return result;
  }

  normalizeTableData(data) {
    const _shapeData = value => {
      if (value) {
        return value;
      }
      return ' - ';
    };
    const result = data.reduce((acumulator, item) => {
      acumulator.push({
        cells: [
          {
            colorLabel: getColorForBrand(item.brand),
            data: _shapeData(item.brand),
            left: true,
          },
          {
            data: _shapeData(formatPercents(item.percent)),
            center: true,
          },
          {
            data: _shapeData(formatPrice(item.amount)),
            right: true,
          },
        ],
      });
      return acumulator;
    }, []);
    return result;
  }

  normalizeRecTableData(data) {
    const _shapeData = value => {
      if (value) {
        return value;
      }
      return ' - ';
    };

    const days = [0, 30, 60, 90, -1];

    return days.map(d => {
      const total =
        data.find(item => item.due_days === d) &&
        data.find(item => item.due_days === d).total;

      const translatedDueDays = translateDueDays(d);

      return {
        cells: [
          {
            colorLabel: getColorByReceivablesGroup(translatedDueDays),
            data: translatedDueDays,
            left: true,
          },
          // {
          //   data: _shapeData(formatPercents(item.percent)),
          //   center: true,
          // },
          {
            data: _shapeData(formatPrice(total)),
            right: true,
          },
        ],
      };
    });
  }

  handleYearChange(side) {
    let { actualYear } = this.state;
    if (side === 'right') {
      if (this.state.actualYear + 1 > new Date().getFullYear()) {
        return;
      }
      actualYear += 1;
    } else {
      actualYear -= 1;
    }

    this.setState(
      {
        actualYear,
      },
      () => {
        this.relaodYear();
      },
    );
  }

  preparePlanData(plan) {
    const { customer, actualYear } = this.state;

    if (!plan) {
      return [];
    }

    let actualProfit = 0;
    let actualPlan = 0;
    let yearPlan = 0;
    const actualMonth = new Date().getMonth();
    plan.turnover_plan.forEach(item => {
      yearPlan += item.plan ? item.plan.amount : 0;
      if (
        item.month <= actualMonth + 1 ||
        actualYear < new Date().getFullYear()
      ) {
        actualProfit += item.actual ? item.actual.amount : 0;
        actualPlan += item.plan ? item.plan.amount : 0;
      }
    });

    const data = [
      {
        label: __('Plán obratu'),
        value: formatPrice({
          amount: yearPlan,
          currency: plan.annual_agreement_plan.currency,
        }),
      },
      {
        label: __('Zmluvný obrat'),
        value:
          customer && customer.trading_limit
            ? formatPrice(customer.trading_limit)
            : ' - ',
      },
      {
        label: __('Doteraz ročný obrat'),
        value: formatPrice({
          amount: actualProfit,
          currency: plan.annual_agreement_plan.currency,
        }),
        color: actualPlan < actualProfit ? 'green' : 'red',
      },
    ];

    return { actualTurnover: actualProfit, data };
  }

  prepareFAData() {
    const { customer } = this.state;

    const data = [
      {
        label: __('FA pred splatnosťou'),
        value:
          customer && customer.invoice_due
            ? formatPrice(customer.invoice_due)
            : ' - ',
      },
      {
        label: __('FA po splatnosti'),
        value:
          customer && customer.invoice_overdue
            ? formatPrice(customer.invoice_overdue)
            : ' - ',
        color: 'red',
      },
      {
        label: __('Bonus za včasné platby'),
        value: '',
      },
      {
        label: __('Bonus za rýchle platby'),
        value: '',
      },
    ];

    return data;
  }

  handleNewsClick(id) {
    this.props.history.push(`/news/${id}`);
  }

  // bonusDataLabelData(actualTurnOver, bonusValue, currency, bonusName) {
  //   // `${__('Pre bonus:')} ${__(bonus.name)} ${__(
  //   //   'ešte potrebujete',
  //   // )} ${formatPrice({
  //   //   currency:
  //   // })}`,

  //   if (actualTurnOver >= bonusValue) {
  //     return {
  //       label: `${__('Získali ste bonus:')}  ${bonusName}`,
  //       value: formatPrice({ amount: actualTurnOver - bonusValue, currency }),
  //     };
  //   }
  //   return {
  //     label: `${__('Pre bonus:')} ${bonusName} ${__('ešte potrebujete:')}`,
  //     value: formatPrice({ amount: bonusValue - actualTurnOver, currency }),
  //   };
  // }

  // prepareBonusesData() {
  //   const { customerBonuses, plan, actualYear } = this.state;

  //   if (plan.turnover_plan) {
  //     let actualProfit = 0;
  //     const actualMonth = new Date().getMonth();

  //     plan.turnover_plan.forEach(item => {
  //       if (
  //         item.month <= actualMonth + 1 ||
  //         actualYear < new Date().getFullYear()
  //       ) {
  //         actualProfit += item.actual ? item.actual.amount : 0;
  //       }
  //     });

  //     return customerBonuses.map(bonus => {
  //       return this.bonusDataLabelData(
  //         actualProfit,
  //         bonus.value,
  //         this.props.user.firm === 'SK' ? 'EUR' : 'CZK',
  //         bonus.name,
  //       );
  //     });
  //   }

  //   return [];
  // }

  render() {
    const {
      brands,
      receivables,
      actualYear,
      contacts,
      plan,
      loading,
      yearReloadLoading,
      loadingContacts,
      error,
      showShopState,
      graphBrands,
      graphReceivables,
      discounts,
      specialDiscounts,
      customerBonuses,
    } = this.state;

    return (
      <MainContainer>
        <ErrorMessage display={error} text={error} />

        <AnimatedFormMessageWrapper display={!loadingContacts}>
          <ContactInfoPanel contacts={contacts} />
        </AnimatedFormMessageWrapper>
        {loading && (
          <LoaderWrapper style={{ width: '100%' }}>
            <Loader size="xl" />
          </LoaderWrapper>
        )}

        <AnimatedFormMessageWrapper display={!loading}>
          <ResponsiveFlexWrapper>
            <StyledPartWrapper width="65%">
              <TurnoverGraph
                header={`${__('Kumulatívne obraty')} ${actualYear}`}
                data={normalizePlan(
                  plan.turnover_plan ? plan.turnover_plan : [],
                )}
                currency={
                  plan.annual_agreement_plan &&
                  plan.annual_agreement_plan.currency
                }
                bonuses={customerBonuses.map(b => ({
                  value: b.value,
                  text: b.name,
                  position: 'end',
                }))}
                loading={loading}
              />
            </StyledPartWrapper>
            <PartWrapper width="35%">
              <SliderWrapper>
                <YearsSlider
                  loading={yearReloadLoading}
                  onClick={side => {
                    this.handleYearChange(side);
                  }}
                  selectedYear={actualYear}
                />
              </SliderWrapper>
              <Bonuses
                bonuses={customerBonuses}
                firm={this.props.user.firm}
                actualTurnover={this.state.actualTurnover}
              />
            </PartWrapper>
          </ResponsiveFlexWrapper>
        </AnimatedFormMessageWrapper>

        <AnimatedFormMessageWrapper display={!loading}>
          <InfoBoxesWrapper>
            <InfoBox data={this.state.planData} />
            <InfoBox last data={this.prepareFAData()} />
            {/* <InfoBox last data={this.prepareBonusesData()} /> */}
          </InfoBoxesWrapper>
        </AnimatedFormMessageWrapper>

        <AnimatedFormMessageWrapper display={!loading && showShopState}>
          {brands && brands.length ? (
            <ResponsiveFlexWrapper>
              <StyledPartWrapper width="65%">
                <BrandsGraph
                  data={graphBrands}
                  header={__('Podiel obratov podľa značky')}
                />
              </StyledPartWrapper>
              <PartWrapper width="35%">
                <InfoTable
                  headers={TableHeaders}
                  data={brands}
                  loading={loading}
                />
              </PartWrapper>
            </ResponsiveFlexWrapper>
          ) : (
            <div />
          )}

          <ResponsiveFlexWrapper style={{ marginTop: rem(32) }}>
            <StyledPartWrapper width="65%">
              <ReceivablesGraph
                data={graphReceivables}
                header={__('Pohľadávky')}
              />
            </StyledPartWrapper>
            <PartWrapper width="35%">
              <InfoTable
                headers={[
                  {
                    data: __(''),
                    left: true,
                  },
                  {
                    data: __('SUMA'),
                    right: true,
                  },
                ]}
                data={receivables}
                loading={loading}
              />
            </PartWrapper>
          </ResponsiveFlexWrapper>

          {discounts && discounts.length ? (
            <ResponsiveFlexWrapper style={{ marginTop: rem(32) }}>
              <PartWrapper width="100%">
                <CustomHeader>{__('Zľavy')}</CustomHeader>
                <InfoTable
                  headers={[
                    {
                      data: __('ZĽAVA'),
                      left: true,
                    },
                    {
                      data: __('PLATNOSŤ OD'),
                      center: true,
                    },
                    {
                      data: __('PLATNOSŤ DO'),
                      center: true,
                    },
                    {
                      data: __('HODNOTA'),
                      right: true,
                    },
                  ]}
                  data={discounts}
                  loading={loading}
                />
              </PartWrapper>
            </ResponsiveFlexWrapper>
          ) : (
            <div />
          )}

          {specialDiscounts && specialDiscounts.length ? (
            <ResponsiveFlexWrapper style={{ marginTop: rem(32) }}>
              <PartWrapper width="100%">
                <CustomHeader>{__('Špeciálne zľavy')}</CustomHeader>
                <InfoTable
                  headers={[
                    {
                      data: __('ZĽAVA'),
                      left: true,
                    },
                    {
                      data: __('PLATNOSŤ OD'),
                      center: true,
                    },
                    {
                      data: __('PLATNOSŤ DO'),
                      center: true,
                    },
                    {
                      data: __('HODNOTA'),
                      right: true,
                    },
                  ]}
                  data={specialDiscounts}
                  loading={loading}
                />
              </PartWrapper>
            </ResponsiveFlexWrapper>
          ) : (
            <div />
          )}
        </AnimatedFormMessageWrapper>

        <AnimatedFormMessageWrapper display={!loading && !showShopState}>
          <CenteredWrapper>
            <Button
              onClick={() =>
                this.setState({
                  showShopState: true,
                })
              }
              primary
            >
              {__('viac o stave obchodu')}
            </Button>
          </CenteredWrapper>
        </AnimatedFormMessageWrapper>

        <AnimatedFormMessageWrapper display={!loading}>
          <CenteredWrapper style={{ marginTop: rem(24) }}>
            {`${__('Dáta na portáli sú aktualizované k:')} ${moment().format(
              'Do. MMMM YYYY, HH:mm',
            )}`}
          </CenteredWrapper>
        </AnimatedFormMessageWrapper>
      </MainContainer>
    );
  }
}

Home.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    surname: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    role: PropTypes.string,
  }),
};

Home.defaultProps = {
  user: {
    name: '',
    surname: '',
    email: '',
    phone: '',
    role: '',
  },
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/Containers/Home/index.jsx